// API STUFF

// ANY .env trouble?
// https://cli.vuejs.org/guide/mode-and-env.html#modes
export const API_BASE = process.env.VUE_APP_API_BASE;

function positiveIntegerEnv(name, fallback) {
  const parsed = Number.parseInt(process.env[name], 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export const UPLOAD_CHUNK_SIZE = positiveIntegerEnv("VUE_APP_UPLOAD_CHUNK_SIZE_BYTES", 16 * 1024 * 1024); // 16MiB
export const UPLOAD_CHUNKED_MIN_SIZE = positiveIntegerEnv("VUE_APP_UPLOAD_CHUNKED_MIN_SIZE_BYTES", 128 * 1024 * 1024); // 128MiB
export const UPLOAD_CHUNKED_PER_FILE_CONCURRENCY = positiveIntegerEnv("VUE_APP_UPLOAD_CHUNKED_PER_FILE_CONCURRENCY", 4);
export const UPLOAD_CHUNKED_GLOBAL_CONCURRENCY = positiveIntegerEnv("VUE_APP_UPLOAD_CHUNKED_GLOBAL_CONCURRENCY", 8);
export const NUMBER_OF_FILES_PER_CHUNK = positiveIntegerEnv("VUE_APP_UPLOAD_FILE_CONCURRENCY", 10);
export const UPLOAD_V2_FILE_CONCURRENCY = positiveIntegerEnv("VUE_APP_UPLOAD_V2_FILE_CONCURRENCY", 4);
export const UPLOAD_V2_CREATE_BATCH_SIZE = positiveIntegerEnv("VUE_APP_UPLOAD_V2_CREATE_BATCH_SIZE", 16);
export const UPLOAD_V2_WARN_FILES_PER_JOB = positiveIntegerEnv("VUE_APP_UPLOAD_V2_WARN_FILES_PER_JOB", 5000);
export const UPLOAD_V2_MAX_FILES_PER_JOB = positiveIntegerEnv("VUE_APP_UPLOAD_V2_MAX_FILES_PER_JOB", 10000);
export const GCS_UPLOAD_MODE = process.env.VUE_APP_GCS_UPLOAD_MODE || "custom"; // "custom" or "library"
export const MAX_UPLOAD_FILE_SIZE_BYTES = 5 * 1024 * 1024 * 1024 * 1024; // 5TiB
export const MAX_UPLOAD_FILE_SIZE_LABEL = "5 TiB";
